export default {
      id: "ic_filter_htw_active-usage",
      viewBox: "0 0 22 18",
      url: "/" + "images/icons.3.109.2.svg#ic_filter_htw_active-usage",
      toString: function () {
        return this.url;
      }
    }